import { noop } from 'lodash';
import { moment } from '@eb/date';
import {
    getDateTimeAsMoment,
    constants as datetimeConstants,
} from '@eb/datetime';
import { TIME_PARAM_FORMAT } from '@eb/eds-utils';
import { DEFAULT_TIME } from './constants';

const { DEFAULT_TIME_FORMAT, ISO_8601_DATE_FORMAT } = datetimeConstants;

/**
 * Creates an empty store, when you just need a store on the page but don't
 * want it to do anything. If you need more than this, you should consider using
 * the createStore method from redux.
 */
export const createEmptyStore = () => ({
    getState: noop,
    subscribe: noop,
    dispatch: noop,
});

/**
 * Given a time, roundup by 30 minutes
 *
 * @param {string} time - formated as (h:mm A)
 * @return {Moment[Object]}
 */
export const roundUpHalfHour = (time) => {
    const timeMoment = moment(time, DEFAULT_TIME_FORMAT);
    const minute = timeMoment.minute();
    let remainder = (30 - minute + 30) % 30;

    if (remainder === 0) {
        remainder = 30;
    }

    return timeMoment.add(remainder, 'minutes');
};

/**
 * setMinEndTime
 *
 * Set minimum time for end date/time
 *
 * @param {Moment[Object]} startDate
 * @param {String} startTime
 * @param {Integer} duration
 * @return {Moment[Object]}
 */
export const setMinEndTime = (startDate, startTime, duration) => {
    const startDateTimeMoment = getDateTimeAsMoment(startDate, startTime);
    let endDateTime = startDateTimeMoment.clone();

    endDateTime = endDateTime.add(duration, 'minutes');

    if (
        startDateTimeMoment &&
        !startDateTimeMoment.isSame(endDateTime, 'day')
    ) {
        return moment('00:00', TIME_PARAM_FORMAT);
    }

    return roundUpHalfHour(startTime);
};

/**
 * setMinStartTime
 *
 * Set minimum time for start date/time
 *
 * @param {Moment[Object]} startDate
 * @return {Moment[Object]}
 */
export const setMinStartTime = (startDate) => {
    const now = moment();

    if (
        startDate &&
        moment(startDate, ISO_8601_DATE_FORMAT).isSame(now, 'day')
    ) {
        return moment(roundUpHalfHour(now, DEFAULT_TIME_FORMAT));
    }

    return moment('00:00', TIME_PARAM_FORMAT);
};

/**
 * adjustEndDateTime
 *
 * Set correct end date/time given start date/time and duration
 *
 * @param {Moment[Object]} startDate
 * @param {String} startTime
 * @param {Integer} duration
 * @return {Moment[Object]}
 */
export const adjustEndDateTime = (startDate, startTime, duration) => {
    const startDateTimeMoment = getDateTimeAsMoment(
        startDate,
        startTime || DEFAULT_TIME,
    );

    if (!startDateTimeMoment) {
        return moment();
    }

    return startDateTimeMoment.add(duration, 'minutes');
};
